"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Preview = exports.CreditFacility = exports.receivableRetroEvent = exports.ReceivableStatus = void 0;
var ReceivableStatus;
(function (ReceivableStatus) {
    ReceivableStatus["Assigned"] = "assigned";
    ReceivableStatus["Unassigned"] = "unassigned";
    ReceivableStatus["Transferred"] = "transferred";
})(ReceivableStatus = exports.ReceivableStatus || (exports.ReceivableStatus = {}));
exports.receivableRetroEvent = [
    'retro-originate',
    'retro-assign',
    'retro-unassign',
];
const receivableNominalEvent = [
    'originate',
    'assign',
    'unassign',
    'transfer',
];
var CreditFacility;
(function (CreditFacility) {
    CreditFacility.LoanTapeMetadataIterable = [
        'commitmentAmount',
        'drawRequestAmountForCalendarMonth',
        'principalBalance',
        'reportingDate',
        'configuredActiveWaivers',
    ];
})(CreditFacility = exports.CreditFacility || (exports.CreditFacility = {}));
var Preview;
(function (Preview) {
    let ReceivableResponseTapePreviewStatus;
    (function (ReceivableResponseTapePreviewStatus) {
        ReceivableResponseTapePreviewStatus["Completed"] = "completed";
        ReceivableResponseTapePreviewStatus["Failed"] = "failed";
        ReceivableResponseTapePreviewStatus["Initiated"] = "initiated";
        ReceivableResponseTapePreviewStatus["Started"] = "started";
    })(ReceivableResponseTapePreviewStatus = Preview.ReceivableResponseTapePreviewStatus || (Preview.ReceivableResponseTapePreviewStatus = {}));
})(Preview = exports.Preview || (exports.Preview = {}));
//# sourceMappingURL=Receivable.js.map